import { Route, Routes } from "react-router-dom";
import {
  ADDFAVORITES,
  ADDPIXDIRECT,
  ADDSOLICITACAOPAGAMENTO,
  ADDSOLICITACAOPAGAMENTONEW,
  ADDSOLICITACAOTRANSFERENCIA,
  ADDSOLICITACAOTRANSFERENCIANEW,
  ADDSUPORT,
  ADDVENDADIGITADA,
  ADDVENDADIGITADACARTAO,
  ADDVENDASRECORRENTES,
  CADASTROCONTASFIXAS,
  CADASTROPLANOSRECORRENCIA,
  CONSULTATRANSACAO,
  CONTASFIXAS,
  CREDITO,
  DADOSPESSOAIS,
  DASHBOARD,
  EDITFAVORITES,
  EXTRACTDETAIL,
  FINANCEIRO,
  LANCAMENTOSFUTUROS,
  LISTADEVENDAS,
  LISTADEVENDASTEMPOREAL,
  LISTAGEMPLANOS,
  LISTAGEMVENDASRECORRENTES,
  CALENDER,
  LISTAGEMVENDASRECORRENTESTRANSACOES,
  NOVAVENDASBOLETOS,
  PAGAMENTOSNOVO,
  PIXDIRECT,
  REGISTERFAVORITES,
  SUPORT,
  TAXASPESSOAIS,
  TRANSFERENCIAS,
  TRANSFERENCIASNOVO,
  VENDADIGITADA,
  VENDASBOLETO,
  VENDASBOLETOS,
  EDITBOLEPIX,
  VENDASBOLEPIX,
  NOVAVENDASBOLEPIX,
  NOVAVENDABOLEPIXLOTE,
  VENDASRECORRENTES,
  LISTADEASSINATURASVINCULADAS,
  DETAILSBOLEPIX,
} from "../constants/paths";
import NotFound from "../pages/404";
import Credito from "../pages/credito";
import Dashboard from "../pages/dahsboard";
import Financeiro from "../pages/financeiro/extracts";
import ExtractsDetails from "../pages/financeiro/extractsDetails";
import FutureReleases from "../pages/financeiro/futureReleases";
import RegisterFavorites from "../pages/financeiro/registerFavorites";
import AddFavorites from "../pages/financeiro/registerFavorites/components/addFavorites";
import AddTransfer from "../pages/financeiro/transferencias/component/newTransfer";
import AddTransferNew from "../pages/financeiro/transferencias-nova/component/newTransfer";
import TransferSolicitatio from "../pages/financeiro/transferencias/transferSolicitation";
import TransferSolicitatioNova from "../pages/financeiro/transferencias-nova/transferSolicitationNova";
// import Vendas from "../pages/vendas";
import AddPayment from "../pages/vendas/boletos/components/newPayment";

import PaymentSolicitation from "../pages/vendas/boletos/paymentSolicitation";
import PaymentSolicitationNovo from "../pages/vendas/pagamentos-novo/paymentSolicitationNovo";
import SalesListDashboard from "../pages/vendas/listaDeVendas/SalesList";
import VendasBoleto from "../pages/vendas/vendasBoleto";
import VendasBolePix from "../pages/vendas/vendaBolePix/index";
import VendasDigitadas from "../pages/vendas/vendasDigitadas";
import AddVendaDigitada from "../pages/vendas/vendasDigitadas/components/addVendaDigitada";
import { JWTToken, PrivateRoute } from "./privateRoute";
import { useRecoilState } from "recoil";
import { permissions } from "../atoms/permissions";
import { allPermissions } from "../atoms/allPermissions";
import { useEffect, useState } from "react";
import PermissionsAPI from "../services/permissionsAPI";
import jwt_decode from "jwt-decode";
import EditFavorites from "../pages/financeiro/registerFavorites/components/editFavorites";
import DadosPessoais from "../pages/dadosCliente/dadosPessoais";
import TarifasCliente from "../pages/dadosCliente/ViewPlanos";
import ContaFixa from "../pages/financeiro/contaFixa.tsx";
import AddAccounts from "../pages/financeiro/contaFixa.tsx/components/addAccounts";
import Suport from "../pages/vendas/servicos";
import AddSuport from "../pages/vendas/servicos/components/addSuport";
import SalesListBoleto from "../pages/vendas/vendasBoleto/SalesListBoleto";
import Calender from "../pages/vendas/vendaBolePix/Calender";
import PageLoteView from "../pages/vendas/vendaBolePix/PageLoteView";
import SalesListBolePix from "../pages/vendas/vendaBolePix/SalesListBoleto";
import PaymentLote from "../pages/vendas/vendaBolePix/PaymetLote";
import ConsultaTransacoes from "../pages/financeiro/consultaTransacoes";
import AddVendaDigitadaCartao from "../pages/vendas/vendasDigitadas/components/addVendaDigitadaCartao";
import Login from "../pages/login";
import VendasPixDireto from "../pages/vendas/vendasPixDireto";
import AddVendaPixDireto from "../pages/vendas/vendasPixDireto/components/addVendaPixDireto";
import VendasRecorrentes from "../pages/vendas/vendasRecorrentes";
import ListagemPlanos from "../pages/vendas/vendasRecorrentes/components/listagemPlanos";
import ListagemVendasRecorrentes from "../pages/vendas/vendasRecorrentes/components/listagemVendasRecorrentes";
import AddPlanosRecorrencia from "../pages/vendas/vendasRecorrentes/components/addPlanosRecorrencia";
import AddVendaRecorrente from "../pages/vendas/vendasRecorrentes/components/addVendaRecorrente";
import ListagemTransacoesVendasRecorrentes from "../pages/vendas/vendasRecorrentes/components/listagemTransacoesVendasRecorrentes";
import ListadeAssinaturasVinculadas from "../pages/vendas/vendasRecorrentes/components/listadeAssinaturasVinculadas";
import { useCookies } from "react-cookie";
import AddPaymentNew from "../pages/vendas/pagamentos-novo/components/newPayment";
import SalesListDashboardTimeReal from "../pages/vendas/listaDeVendasTempoReal/SalesList";
import EditBoletoSettings from "../pages/vendas/vendaBolePix/EditBoletoSettings";
function ComponentRoutes() {
  const permsList = useRecoilState(permissions)[0];
  const [permissionsList, setPermissionsList] = useState(permsList);
  const [isNotEmpty, setIsNotEmpty] = useState(false);

  const [cookies, setCookie, removeCookie] = useCookies(); //['color', 'logo1', 'logo2'] ['color', 'logo']

  const token = cookies.token ? cookies.token : localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");

  async function getPerms(id: any, id2?: any) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(response);
      setIsNotEmpty(!(response.length > 0));
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (permissionsList.length === 0 && !isNotEmpty) {
      getPerms(Number(jwtToken.idCliente));
    }
  }, [permissionsList]);
  return (
    <>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route
          path={DASHBOARD}
          element={
            <PrivateRoute id={-2} permsList={permissionsList}>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={FINANCEIRO}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <Financeiro />
            </PrivateRoute>
          }
        />

        <Route
          path={EXTRACTDETAIL}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <ExtractsDetails />
            </PrivateRoute>
          }
        />
        <Route
          path={REGISTERFAVORITES}
          element={
            <PrivateRoute id={36} id2={20} permsList={permissionsList}>
              <RegisterFavorites />
            </PrivateRoute>
          }
        />
        <Route
          path={EDITFAVORITES}
          element={
            <PrivateRoute id={36} id2={20} permsList={permissionsList}>
              <EditFavorites />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDFAVORITES}
          element={
            <PrivateRoute id={36} id2={20} permsList={permissionsList}>
              <AddFavorites />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={VENDAS}
          element={
            <PrivateRoute id={19} permsList={permissionsList}>
              <Vendas />
            </PrivateRoute>
          }                     
        /> */}
        <Route
          path={LISTADEVENDAS}
          element={
            <PrivateRoute id={26} permsList={permissionsList}>
              <SalesListDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={LISTADEVENDASTEMPOREAL}
          element={
            <PrivateRoute id={26} permsList={permissionsList}>
              <SalesListDashboardTimeReal />
            </PrivateRoute>
          }
        />
        <Route
          path={CREDITO}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <Credito />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASBOLETOS}
          element={
            <PrivateRoute id={2} permsList={permissionsList}>
              <PaymentSolicitation />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASBOLEPIX}
          element={
            <PrivateRoute id={43} permsList={permissionsList}>
              <SalesListBolePix />
            </PrivateRoute>
          }
        />
        <Route
          path={EDITBOLEPIX}
          element={
            <PrivateRoute id={-2} permsList={permissionsList}>
              <EditBoletoSettings />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGAMENTOSNOVO}
          element={
            <PrivateRoute id={37} permsList={permissionsList}>
              <PaymentSolicitationNovo />
            </PrivateRoute>
          }
        />
        <Route
          path={NOVAVENDASBOLETOS}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <VendasBoleto />
            </PrivateRoute>
          }
        />
        <Route
          path={NOVAVENDASBOLEPIX}
          element={
            <PrivateRoute id={44} permsList={permissionsList}>
              <VendasBolePix />
            </PrivateRoute>
          }
        />

        <Route
          path={DETAILSBOLEPIX}
          element={
            <PrivateRoute id={45} permsList={permissionsList}>
              <PageLoteView />
            </PrivateRoute>
          }
        />

        <Route
          path={NOVAVENDABOLEPIXLOTE}
          element={
            <PrivateRoute id={45} permsList={permissionsList}>
              <PaymentLote />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASBOLETO}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <SalesListBoleto />
            </PrivateRoute>
          }
        />
        <Route
          path={CALENDER}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <Calender />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={PIXDIRECT}
          element={
            <PrivateRoute id={33} permsList={permissionsList}>
              <VendasPixDireto />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDPIXDIRECT}
          element={
            <PrivateRoute id={33} permsList={permissionsList}>
              <AddVendaPixDireto />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={VENDADIGITADA}
          element={
            <PrivateRoute id={21} permsList={permissionsList}>
              <VendasDigitadas />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDVENDADIGITADA}
          element={
            <PrivateRoute id={25} permsList={permissionsList}>
              <AddVendaDigitada />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDVENDADIGITADACARTAO}
          element={
            <PrivateRoute id={27} permsList={permissionsList}>
              <AddVendaDigitadaCartao />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOPAGAMENTO}
          element={
            <PrivateRoute id={2} permsList={permissionsList}>
              <AddPayment />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOPAGAMENTONEW}
          element={
            <PrivateRoute id={37} permsList={permissionsList}>
              <AddPaymentNew />
            </PrivateRoute>
          }
        />
        {/*     <Route
          path={VENDASBOLETOS}
          element={
            <PrivateRoute id={37} permsList={permissionsList}>
              <AddPaymentNew />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={TRANSFERENCIAS}
          element={
            <PrivateRoute id={20} permsList={permissionsList}>
              <TransferSolicitatio />
            </PrivateRoute>
          }
        />
        <Route
          path={TRANSFERENCIASNOVO}
          element={
            <PrivateRoute id={36} permsList={permissionsList}>
              <TransferSolicitatioNova />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOTRANSFERENCIA}
          element={
            <PrivateRoute id={20} permsList={permissionsList}>
              <AddTransfer />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOTRANSFERENCIANEW}
          element={
            <PrivateRoute id={36} permsList={permissionsList}>
              <AddTransferNew />
            </PrivateRoute>
          }
        />
        <Route
          path={LANCAMENTOSFUTUROS}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <FutureReleases />
            </PrivateRoute>
          }
        />
        <Route
          path={DADOSPESSOAIS}
          element={
            <PrivateRoute id={-2} permsList={permissionsList}>
              <DadosPessoais />
            </PrivateRoute>
          }
        />
        <Route
          path={TAXASPESSOAIS}
          element={
            <PrivateRoute id={38} permsList={permissionsList}>
              <TarifasCliente />
            </PrivateRoute>
          }
        />
        <Route
          path={CONTASFIXAS}
          element={
            <PrivateRoute id={24} permsList={permissionsList}>
              <ContaFixa />
            </PrivateRoute>
          }
        />
        <Route
          path={CADASTROCONTASFIXAS}
          element={
            <PrivateRoute id={24} permsList={permissionsList}>
              <AddAccounts />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={SUPORT}
          element={
            <PrivateRoute id={21} permsList={permissionsList}>
              <Suport />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSUPORT}
          element={
            <PrivateRoute id={21} permsList={permissionsList}>
              <AddSuport />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={CONSULTATRANSACAO}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <ConsultaTransacoes />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASRECORRENTES}
          element={
            <PrivateRoute id={14} permsList={permissionsList}>
              <VendasRecorrentes />
            </PrivateRoute>
          }
        />
        <Route
          path={LISTAGEMPLANOS}
          element={
            <PrivateRoute id={15} permsList={permissionsList}>
              <ListagemPlanos />
            </PrivateRoute>
          }
        />
        <Route
          path={LISTAGEMVENDASRECORRENTES}
          element={
            <PrivateRoute id={15} permsList={permissionsList}>
              <ListagemVendasRecorrentes />
            </PrivateRoute>
          }
        />
        <Route
          path={CADASTROPLANOSRECORRENCIA}
          element={
            <PrivateRoute id={17} permsList={permissionsList}>
              <AddPlanosRecorrencia />
            </PrivateRoute>
          }
        />
        <Route
          path={LISTADEASSINATURASVINCULADAS}
          element={
            <PrivateRoute id={17} permsList={permissionsList}>
              <ListadeAssinaturasVinculadas />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDVENDASRECORRENTES}
          element={
            <PrivateRoute id={17} permsList={permissionsList}>
              <AddVendaRecorrente />
            </PrivateRoute>
          }
        />
        <Route
          path={LISTAGEMVENDASRECORRENTESTRANSACOES}
          element={
            <PrivateRoute id={15} permsList={permissionsList}>
              <ListagemTransacoesVendasRecorrentes />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
}
export default ComponentRoutes;
